import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  signal,
} from '@angular/core';
import { TopHeaderTabComponent } from './top-header-tab/top-header-tab.component';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { TopHeaderSingleTabComponent } from './top-header-single-tab/top-header-single-tab.component';
import { HorizontalScrollDetectionDirective } from '../../../directives/HorizontalScrollDetection.directive';
import { NavigationItem } from '../../../interfaces/navigationList.interface';
import { PageContainerService } from '../../../services/page-container.service';
import { TopHeaderStandaloneTitleComponent } from './top-header-standalone-title/top-header-standalone-title.component';

@Component({
  selector: 'st-top-header-tabs',
  standalone: true,
  imports: [
    CommonModule,
    TopHeaderTabComponent,
    HorizontalScrollDetectionDirective,
    TopHeaderSingleTabComponent,
    TopHeaderStandaloneTitleComponent,
  ],
  templateUrl: './top-header-tabs.component.html',
  styleUrls: ['./top-header-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopHeaderTabsComponent {
  singleTab = signal(false);

  tabs = [
    {
      name: 'tab one',
      url: '',
    },
    {
      name: 'tab two',
      url: '',
    },
    {
      name: 'tab three',
      url: '',
    },
  ];
  activeChild!: NavigationItem | null;

  activeRoute$ = this.pageContainerService.activeSectionRoute.pipe(
    tap(item => {
      this.getRoutePath(item);
    }),
  );

  changeTab$ = this.pageContainerService.changeTab$.pipe(
    tap(tab => {
      this.activeChild = tab;
    }),
  );
  public standaloneTitle = this.pageContainerService.standAlonePageTitle;

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
    readonly cd: ChangeDetectorRef,
  ) {}

  getRoutePath(item: NavigationItem | null) {
    if (item) {
      let currentPath = this.pageContainerService
        .getRoutePath()
        .find(x => x.url === this.router.url.split('?')[0])?.routePath;

      const index = item.children.findIndex(
        y => y && currentPath && y.id === currentPath[1],
      );
      if (index !== -1) {
        this.activeChild = item.children[index];
      } else {
        return;
      }
    }
  }
  onScrollChange(isScrollable: boolean) {
    this.singleTab.set(isScrollable);
    if (isScrollable) {
      console.log('Component has horizontal scroll.');
    } else {
      console.log('Component does not have horizontal scroll.');
    }
  }
}
